import { render } from "./HeaderSettingsPanel.vue?vue&type=template&id=527e2498&scoped=true&ts=true"
import script from "./HeaderSettingsPanel.vue?vue&type=script&lang=ts"
export * from "./HeaderSettingsPanel.vue?vue&type=script&lang=ts"

import "./HeaderSettingsPanel.vue?vue&type=style&index=0&id=527e2498&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527e2498"]])

export default __exports__